import React from 'react';
import PropTypes from 'prop-types';

import { OrganizationLogo } from 'modules/common/components';
import { AuthorizationForm } from 'shared/components';
import BackgroundLayout from '../BackgroundLayout';

const AuthorizationPageLayout = ({ children }) => (
  <BackgroundLayout>
    <AuthorizationForm
      logo={ <OrganizationLogo accessibilityEnabled /> }
      form={ children }
    />
  </BackgroundLayout>
);

AuthorizationPageLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AuthorizationPageLayout;
